/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleBannerTiles_browseContentModule = {
    readonly title: string | null;
    readonly description: string | null;
    readonly mainImage: string | null;
    readonly tiles: ReadonlyArray<{
        readonly imageUrl: string | null;
        readonly title: string | null;
        readonly linkData: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly " $refType": "SbSharedContentModuleBannerTiles_browseContentModule";
};
export type SbSharedContentModuleBannerTiles_browseContentModule$data = SbSharedContentModuleBannerTiles_browseContentModule;
export type SbSharedContentModuleBannerTiles_browseContentModule$key = {
    readonly " $data"?: SbSharedContentModuleBannerTiles_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedContentModuleBannerTiles_browseContentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SbSharedContentModuleBannerTiles_browseContentModule",
  "type": "ContentModuleBannerTiles",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tiles",
      "storageKey": null,
      "args": null,
      "concreteType": "BrowseContentModuleTile",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'd806dace3670d2b5b409515b6f7eeec4';
export default node;
